import React from "react";
import { Box, Typography, Stack, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import SocialMediaIcons from "../../Components/SocialMediaIcons";

const FooterBottom = () => (
  <Box sx={{ bgcolor: "#000", color: "#fff", px: { xs: 2, md: 3 }, py: 3 }}>
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "center", md: "center" }}
      spacing={2}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 1.5, sm: 3 }}
        alignItems="center"
        textAlign={{ xs: "center", sm: "left" }}
      >
        <MuiLink
          component={RouterLink}
          to="/privacy-policy"
          color="inherit"
          underline="hover"
        >
          Privacy & Policy
        </MuiLink>

        <MuiLink
          component={RouterLink}
          to="/terms-conditions"
          color="inherit"
          underline="hover"
        >
          Terms & Conditions
        </MuiLink>

        <Typography variant="body2">
          © 2026 GAAMI WORKS CONSULTING PRIVATE LIMITED
        </Typography>
      </Stack>

      <Box sx={{ textAlign: { xs: "center", md: "right" } }}>
        <Typography
          variant="body2"
          sx={{ mb: 0.5, opacity: 0.8, display: { md: "none" } }}
        >
          Follow us
        </Typography>
        <SocialMediaIcons color="#fff" justifyContent="center" />
      </Box>
    </Stack>
  </Box>
);

export default FooterBottom;
